var defaultCssVariables = {
  accentColor: '#009688',
  pageBackground: '#fff',
  headerBackground: '#fff',
  headerTextColor: 'var(--text-color)',
  textColor: '#000',
  linkColor: 'var(--accent-color)',
  sidebarWidth: '280px',
  sidebarBackground: 'var(--page-background)',
  sidebarLinkColor: '#444',
  sidebarLinkActiveColor: '#000',
  sidebarLinkArrowColor: '#999',
  mainBackground: 'var(--page-background)',
  borderColor: '#eaeaea',
  headerHeight: '55px',
  codeFont: 'SFMono-Regular,Consolas,Liberation Mono,Menlo,Courier,monospace',
  tipColor: 'rgb(6, 125, 247)',
  successColor: '#42b983',
  warningColor: '#ff9800',
  dangerColor: 'rgb(255, 0, 31)',
  navLinkColor: '#2c3e50',
  navLinkBorderColor: 'var(--accent-color)',
  codeBlockBackground: '#011627',
  codeBlockTextColor: 'white',
  codeBlockShadowColor: '#333',
  codeBlockShadowWidth: '0px',
  highlightedLineBackground: '#022a4b',
  highlightedLineBorderColor: '#ffa7c4',
  inlineCodeColor: 'rgb(116, 66, 16)',
  inlineCodeBackground: 'rgb(254, 252, 191)',
  loaderPrimaryColor: '#f3f3f3',
  loaderSecondaryColor: '#ecebeb',
  tableHeaderBackground: '#fafafa',
  tableHeaderColor: '#666',
  docuteSelectHeight: '38px',
  searchIconColor: '#999',
  searchFocusBorderColor: '#ccc',
  searchFocusIconColor: '#333',
  searchResultHoverBackground: '#f9f9f9'
};
var darkCssVariables = Object.assign({}, defaultCssVariables, {
  headerBackground: 'var(--page-background)',
  sidebarLinkColor: 'var(--text-color)',
  sidebarLinkActiveColor: 'var(--text-color)',
  textColor: 'hsla(0,0%,100%,0.88)',
  pageBackground: '#2f3136',
  navLinkColor: 'var(--text-color)',
  borderColor: '#3e4147',
  highlightedLineBackground: '#022a4b',
  highlightedLineBorderColor: '#ffa7c4',
  inlineCodeColor: '#e6e6e6',
  inlineCodeBackground: '#373c49',
  loaderPrimaryColor: 'hsla(0, 0%, 100%, 0.08)',
  loaderSecondaryColor: 'hsla(0, 0%, 100%, 0.18)',
  contentLinkBorder: '2px solid hsla(0, 0%, 100%, 0.28)',
  contentLinkHoverBorderColor: 'currentColor',
  tableHeaderBackground: 'var(--border-color)',
  tableHeaderColor: '#868686',
  searchIconColor: '#999',
  searchFocusBorderColor: '#999',
  searchFocusIconColor: '#ccc',
  searchResultBackground: '#27292f',
  searchResultHoverBackground: '#1e2025'
});
export { defaultCssVariables, darkCssVariables };